<template>
  <div class="gene-list">
    <div class="swipe-container">
      <div v-if="list.length === 0" class="nothing">
        <p class="show2" v-show="this.show2"><img src="../assets/images/wait.png" alt="" /></p>
        <i v-show="this.show1" class="iconfont iconnothing heath"></i>
        <p v-show="this.show1">{{ text }}</p>
      </div>
      <van-swipe v-else :autoplay="3000" @change="handleChange">
        <van-swipe-item v-for="(item, index) in list" :key="index">
          <div style="text-align: center">
            <span class="gene-name" v-if="item.inherit_name">{{ item.inherit_name }}</span>
            <span class="gene-name">{{ item.gene_name }}</span>
            <span class="fake" v-show="item.fake_gene">Ψ</span>
          </div>

          <!--  疾病风险 -->
          <div v-if="isshow === 'genetic'">
            <div class="flex flex-headeritem">
              <h5>核苷酸</h5>
              <h5>氨基酸</h5>
              <h5>纯合/杂合</h5>
            </div>
            <template v-for="k in item">
              <div class="flex flex-bodyitem">
                <span>{{ k.hgs }}</span>
                <span>{{ k.ajs }}</span>
                <span>{{ k.homo }}</span>
              </div>
            </template>
          </div>

          <!--          -->
          <div class="flex" v-if="isshow === 'susceptible'">
            <div class="flex-item">
              <h5>位点</h5>
              <span>{{ item.rs }}</span>
            </div>
            <div class="flex-item">
              <h5>基因型</h5>
              <span v-if="gdb3">{{ item.genotype }}</span>
              <span v-else>{{ item.gene_ref }}</span>
            </div>
            <div v-if="gdb2" class="flex-item">
              <h5>检测基因型</h5>
              <span>{{ item.genotype }}</span>
            </div>
            <div class="flex-item">
              <h5>评价</h5>
              <i class="iconfont iconyuan high" v-if="item.repute === 'bad'"></i>
              <i class="iconfont iconyuan general" v-if="item.repute === 'normal'"></i>
              <i class="iconfont iconyuan low" v-if="item.repute === 'benefit'"></i>
            </div>
          </div>

          <!--    单基因病      -->
          <div class="flex" v-if="isshow === 'inherit'">
            <div class="flex-item">
              <h5>位点</h5>
              <span>{{ item.rs }}</span>
            </div>
            <div class="flex-item">
              <h5>遗传模式</h5>
              <span>{{ item.dis_inherit_type || item.inherit_type || "复杂" }}</span>
            </div>
            <div class="flex-item">
              <h5>基因型</h5>
              <span>{{ item.genotype }}</span>
            </div>
          </div>

          <!--    可治性罕见病      -->
          <div class="flex" v-if="isshow === 'rare'">
            <div class="flex-item">
              <h5>核苷酸变异</h5>
              <span>{{ item.hgs }}</span>
            </div>
            <div class="flex-item">
              <h5>氨基酸变异</h5>
              <span>{{ item.ajs }}</span>
            </div>
            <div class="flex-item">
              <h5>纯合/杂合</h5>
              <span>{{ item.mutation_type }}</span>
            </div>
            <div class="flex-item">
              <h5>遗传模式</h5>
              <span>{{ item.dis_inherit_type || item.inherit_type }}</span>
            </div>
          </div>

          <!--    精准用药      -->
          <div class="flex" v-if="isshow === 'drug'">
            <div class="flex-item">
              <h5>{{ point }}</h5>
              <span>{{ item.rs }}</span>
            </div>
            <div class="flex-item">
              <h5>{{ genetype }}</h5>
              <span>{{ item.genotype || "_" }}</span>
            </div>
            <div class="flex-item">
              <h5>证据水平</h5>
              <p v-if="gdb3">{{ item.conclusion_level }}</p>
              <p v-if="gdb2">{{ item.reliability }}</p>
            </div>
          </div>

          <div v-if="isshow === 'drug'" style="margin-top: 10px; padding: 0 20px">
            <p>位点结论: {{ item.conclusion }}</p>
            <p v-if="item.summary !== ''">解读注释: <span @click="showPopup(item.summary)" style="color: #18a7ff">点此查看</span></p>
          </div>

          <!--    特质基因      -->
          <div class="flex" v-if="isshow === 'talent'">
            <div class="flex-item" v-if="item.rs">
              <h5>位点</h5>
              <span>{{ item.rs }}</span>
            </div>
            <div class="flex-item" v-if="item.gene_ref">
              <h5>参考</h5>
              <span>{{ item.gene_ref }}</span>
            </div>
            <div class="flex-item" v-if="item.genotype">
              <h5>基因型</h5>
              <span>{{ item.genotype }}</span>
            </div>

            <div class="flex-item" v-if="item.haplotype">
              <h5>单倍型</h5>
              <span>{{ item.haplotype }}</span>
            </div>

            <div class="flex-item" v-if="item.result">
              <h5>检测结果</h5>
              <span>{{ item.result }}</span>
            </div>

          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 精准用药 -->
    <p class="note" v-if="note && isshow === 'drug'">{{ note }}</p>

    <!--    -->
    <div v-if="isshow === 'genetic' && list.length !== 0">
      <p class="info pagenum">{{ index + 1 }} / {{ list.length }}</p>
      <p class="unscramble assessment">风险评估：<span>遗传性位点筛查检出高风险变异位点</span></p>
    </div>

    <!--    -->
    <div v-if="isshow === 'susceptible' && list.length !== 0">
      <p class="info">
        <span>{{ index + 1 }} / {{ list.length }}</span>
        注: 本项目共计评价{{ list.length }}个位点
      </p>
      <p style="padding: 1em 2em 0; font-size: 12px">
        <i class="iconfont iconyuan high"></i>
        <i class="iconfont iconyuan general"></i>
        <i class="iconfont iconyuan low"></i>
        分别代表有害突变、正常基因型、良性突变
      </p>
      <p v-if="isRs" style="padding: 1em 2em 0; font-size: 12px">备注：APOE评价结果为rs7412和rs429358两个位点综合判定。</p>
    </div>

    <!--  单基因病 && 可治性罕见病  -->
    <div v-if="(isshow === 'inherit' || isshow === 'rare') && list.length !== 0">
      <p class="info">
        <span>{{ index + 1 }} / {{ data.length }}</span>
        注: 遗传模式AR:常染色体隐性遗传<br />
        遗传模式AD:常染色体显性遗传
      </p>
    </div>

    <!--  查看解读注释模态框  -->
    <div v-if="isshow === 'drug' && list.length !== 0">
      <p class="info">
        <span>{{ index + 1 }} / {{ data.length }}</span>
      </p>
      <van-popup v-model="popupVisible" class="summary-popup">
        <div style="padding-bottom: 5px">
          解读注释
          <van-icon name="cross" style="width: 10px; float: right; margin-top: 2px" @click="popupVisible = false" />
        </div>
        {{ popup }}
      </van-popup>
    </div>

    <!--  特质基因  -->
    <div v-if="isshow === 'talent' && list.length !== 0">
      <p class="info">
        <span>{{ index + 1 }} / {{ data.length }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "isshow", "note", "name", "nontumorous"],
  data: function () {
    return {
      show1: false,
      show2: true,
      gdb3: false,
      gdb2: false,
      list: [],
      index: 0, // 第几个
      point: "位点/星型",
      genetype: "基因型/代谢/携带",
      popup: "无",
      popupVisible: false,
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      isRs: false, // 若同时出现rs429358和rs7412的基因型,显示备注
      text: "未见遗传性突变", //动态文字
    };
  },
  methods: {
    show() {
      setTimeout(() => {
        (this.show1 = true), (this.show2 = false);
      }, 600);
    },

    // 判断是否同时出现rs429358和rs7412的基因型
    isShowRs() {
      let that = this;
      let arr = [];
      this.list.forEach((item) => {
        arr.push(item.rs);
        if (arr.indexOf("rs429358") > -1 && arr.indexOf("rs7412") > -1 && that.name === "阿尔茨海默病") {
          that.isRs = true;
        }
      });
    },
    handleChange(index) {
      this.index = index;
    },
    showPopup(text) {
      this.popup = text;
      this.popupVisible = true;
    },
    getData() {
      this.handleChange(0);
      this.list = this.data;
      this.isShowRs();
    },
  },
  watch: {
    data() {
      this.getData();
    },
  },
  mounted() {
    if (this.nontumorous) {
      this.text = "位点结论未知，详见PDF报告";
    }
    this.show();
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true;
    } else {
      this.gdb2 = true;
    }
    this.getData();
    this.point = this.child ? "位点/星型" : "位点";
    this.genetype = this.child ? "基因型/代谢/携带" : "基因型";
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/functions";
.show2 img {
  position: relative;
  top: -0.7rem;
  width: 1.4rem;
  height: 1.4rem;
}
.gene-list {
  color: #000;
}
.swipe-container {
  height: pxToRem(360px);
}
.summary-popup {
  z-index: 2003;
  border-radius: 4px;
  padding: 18px;
  width: 80%;
}
.unscramble {
  padding-left: pxToRem(40px);
  margin-top: pxToRem(20px);

  span {
    color: #007aff;
  }
}
.pagenum {
  text-align: left;
  padding: 0 pxToRem(40px);
}
.fake {
  display: inline-block;
  width: pxToRem(40px);
  color: red;
}
.note {
  padding: 0 pxToRem(40px);
}
.flex-headeritem {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.flex-headeritem h5{
  width: .7rem;
  text-align: right;
}
.flex-bodyitem {
  display: flex;
  justify-content: space-around;
  padding-top: 0;
}
.flex-bodyitem span{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/GeneList.vue